import styles from './styles.module.scss';
import React from 'react';
import {Col, Row} from 'reactstrap';
import {LabelAddress, LabelCountry} from '../Labels';

class PublicCertificationsSite extends React.Component {
  render() {
    const {items} = this.props;

    return (
      <ul className={styles['public__certifications']}>
        {items.map((item, index) => {
          const {countries_id, street, post_code, city, state, scope} = item;

          return (
            <li key={index}>
              <Row>
                <Col lg="4">
                  <LabelCountry tag="h4" country_id={countries_id} />
                  <LabelAddress
                    street={street}
                    postcode={post_code}
                    state={state}
                    city={city}
                  />
                </Col>

                {scope && (
                  <Col lg="8">
                    <pre>{scope}</pre>
                  </Col>
                )}
              </Row>
            </li>
          );
        })}
      </ul>
    );
  }
}

export default PublicCertificationsSite;
